const ContactSection = Object.freeze({
  PARENT: 'parent',
  ENFANT: 'enfant',
  ETAT_CIVIL: 'etat-civil',
  GENERAL: 'general'
})

export default ContactSection
